<!-- RIGHT SIDEBAR STRUCTURE - Generate Report only with collapse/expand -->
<div class="menu">
	<div class="icon" (click)="toggleMenu(true)">{{ expandRight ? 'close' : 'menu' }}</div>
</div>
<div class="items" [ngClass]="{ expand: expandRight }">
	<!-- Generate Report Section -->
	<div class="report-section" [ngClass]="{ expand: expandRight }">
		<div class="report-icon" *ngIf="!expandRight" title="Generate Report">description</div>
		<ng-container *ngIf="expandRight">
			<div class="report-title">Generate Report</div>
			<button class="report-button" (click)="generateExcelReport()">Generate Excel Report</button>
			<div class="report-description">Export your findings to an Excel sheet.</div>
		</ng-container>
	</div>

	<!-- Toggle button at bottom -->
	<div class="toggle" [ngClass]="{ expand: expandRight }">
		<div class="icon" (click)="toggleMenu()">{{ expandRight ? 'keyboard_double_arrow_right' : 'keyboard_double_arrow_left' }}</div>
	</div>
</div>

<footer [ngClass]="{ expand: expandRight }"></footer>
